import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/bff/client';

import IconGeneric from '../../ui/icon/icon-generic';

const LanguageSwitcherMenu = props => {
  const { supported, languageSelected } = props;

  const handlerOnChange = event => {
    props.onChange(event.target.value);
  };

  return (
    <span className="language-switcher ga-menu-language-switcher">
      <span className="language-switcher__menu">
        <span className="language-switcher__menu-text">
          {props.abbreviated
            ? languageSelected
            : trans(`locale.${languageSelected}`)}
        </span>
        <IconGeneric name="angle-down" color="inherit" size="small" />
      </span>
      <select
        defaultValue={languageSelected}
        className="language-switcher__select"
        onChange={handlerOnChange}
      >
        {Object.keys(supported)
          .sort()
          .map(lang => (
            <option key={lang} value={lang}>
              {supported[lang].name}
            </option>
          ))}
      </select>
    </span>
  );
};

LanguageSwitcherMenu.prototypes = {
  propTypes: {
    supported: PropTypes.objectOf(
      PropTypes.shape({
        name: PropTypes.string
      })
    ),
    languageSelected: PropTypes.string,
    onChange: PropTypes.func
  }
};

export default LanguageSwitcherMenu;
